// Kept across logout: snapshots from an earlier login must never be restored,
// even when IndexedDB cleanup is blocked by the browser or another tab.
const KEY = "primepoint-query-cache-epoch";
export function readQueryCacheEpoch(): string | null {
    try {
        return localStorage.getItem(KEY) ?? "";
    } catch {
        return null;
    }
}
export function invalidateQueryCacheEpoch(): boolean {
    try {
        localStorage.setItem(
            KEY,
            Array.from(crypto.getRandomValues(new Uint32Array(4)), (value) =>
                value.toString(16).padStart(8, "0"),
            ).join(""),
        );
        return true;
    } catch {
        return false;
    }
}
